import http from '../http'

export default {
    all() {
        return http.get('cursos-especialidades')
    },

    get(especialidad) {
        return http.get(`cursos-especialidades/${especialidad}`)
    },

    create(payload) {
        const formData = new FormData()

        Object.entries(payload).forEach(([key, value], index) => {
            formData.append(key, value)
        })

        return http.post('cursos-especialidades', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            }
        })
    },

    update(especialidad, payload) {
        const formData = new FormData()

        Object.entries(payload).forEach(([key, value], index) => {
            formData.append(key, value)
        })

        formData.append("_method", 'PUT')
        return http.post(`cursos-especialidades/${especialidad}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            }
        })
    },

    save({id, ...payload}) {
        return id === undefined ? this.create(payload) : this.update(id, payload)
    },
}